/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

export const ContractsTabelHeader = [
  {
    headerName: 'Contract ID',
    field: 'contractSeqNum',
    editable: false,
    sortable: true,
    cellRenderer: 'ContractIdRenderer',
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_400,
    cellRenderer: 'ContractNameRenderer',
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Contact Type Cd',
    field: 'contactTypeCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
